import { validations } from './validations';

/**
 * Final questions
 */
export const userInfoQuestions = [
  {
    id: 'email',
    question: 'Deixe seu e-mail e ganhe descontos exclusivos em cervejas!',
    subtitle: 'Ao informar seu e-mail, você concorda em receber os resultados da pesquisa em primeira mão, além de informações dos nossos patrocinadores.',
    type: 'email',
    validation: () => { false },
  }
];
